import { Modal, Radio } from "antd";
import { useState } from "react";
import SignagePlayer from "../SignagePlayer";

const PreviewMedia = ({ isModalOpen, media, closeModal }) => {
  // "horizontal"/"vertical" are kept as the internal values since the
  // preview-media CSS classes key off them - only the displayed labels
  // are Landscape/Portrait to match the orientation field elsewhere.
  const [orientation, setOrientation] = useState(
    media.orientation === "portrait" ? "vertical" : "horizontal"
  );

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const modalWidth = orientation === "horizontal" ? 450 : 275; // adjust as needed
  // Matches the fixed preview-media.horizontal/.vertical CSS dimensions -
  // must track orientation, otherwise the container (and the TV frame
  // wrapping it) stays a fixed 400px tall for both, making the landscape
  // frame come out nearly square instead of a wide 16:9 shape.
  const playerHeight = orientation === "horizontal" ? 225 : 400;

  return (
    <Modal
      title={`Preview Media - ${media.title}`}
      open={isModalOpen}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
      width={modalWidth}
    >
      <div className="mb-3">
        <label className="form-label me-3">Orientation</label>
        <Radio.Group
          onChange={handleOrientationChange}
          value={orientation}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value="horizontal">Landscape</Radio>
          <Radio value="vertical">Portrait</Radio>
        </Radio.Group>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className={`tv-frame ${orientation}`}>
          <div
            className={`preview-media-container ${orientation}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: playerHeight,
              overflow: "hidden",
            }}
          >
            <SignagePlayer
              playlist={[
                {
                  media: { ...media, file_data: JSON.parse(media.file_data) },
                  duration: 10000,
                },
              ]}
              classNames={`preview-media ${orientation}`}
              enableControls={true}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewMedia;
